import {useQuery} from '@tanstack/react-query';
import {Contract, QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

type UseContractsArgs = {
  housingId?: string;
  isContractEnabled?: boolean;
};

function useContracts({housingId, isContractEnabled}: UseContractsArgs) {
  const enabled = Boolean(isContractEnabled && housingId);

  const {data, error, isLoading} = useQuery<Contract[], Error>({
    queryKey: [QUERY_CACHE_KEYS.contracts, housingId],
    queryFn: () => API.documents.getContracts(`housing_sample_id=${housingId}`),
    enabled,
    refetchOnWindowFocus: false,
  });

  return {
    isLoadingContracts: enabled && isLoading,
    isContractsError: !!error,
    contracts: data,
  };
}

export {useContracts};
